import ReactGA from 'react-ga4';

// Initialize GA with your tracking ID
export const initGA = (trackingId: string) => {
  if (typeof window !== 'undefined') {
    ReactGA.initialize(trackingId);
    console.log('GA initialized');
  }
};

// Track pageviews
export const trackPageView = (path: string) => {
  if (typeof window !== 'undefined') {
    ReactGA.send({ hitType: 'pageview', page: path });
    console.log(`Pageview tracked: ${path}`);
  }
};

// Track events
export const trackEvent = (category: string, action: string, label?: string, value?: number) => {
  if (typeof window !== 'undefined') {
    ReactGA.event({
      category,
      action,
      label,
      value,
    });
  }
};

// Track exceptions
export const trackException = (description: string, fatal: boolean = false) => {
  if (typeof window !== 'undefined') {
    ReactGA.event({
      category: 'Exception',
      action: description,
      label: fatal ? 'Fatal' : 'Non-Fatal',
    });
  }
}; 